"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A function which returns whatever is passed into it
 *
 * @module identity
 * @func
 * @since 1.5.0
 * @params {*} val
 * @return {*}
 * @example
 *
 *     identity(5); //=> 5
 *     identity({}); //=> {}
 */

var identity = function identity(val) {
  return val;
};

exports.default = identity;